import { styled } from 'styled-components';

import { Icon, Rating, SpaceBetween, Typography, tk } from '@sunwebgroup/ui-components';

import { useTransportSelector } from '@/domain/prices/transports/hooks';
import type { TripSummaryItem } from '@/domain/prices/transports/types';
import { useIntl } from '@/intl';

const ExtraInfoText = styled(Typography)`
  display: block;
  margin-left: 20px;
`;

const HeaderWrapper = styled.div`
  display: flex;

  ${Icon} {
    margin-right: ${tk('spacing_2xs')};
  }
`;

const Stars = styled(Rating)`
  margin-left: auto;
  @media ${tk('mq_desktop_sm')} {
    margin-left: 0;
  }
`;

const Item = ({ header, extraInfo }: TripSummaryItem) => {
  return (
    <div>
      <HeaderWrapper>
        <Icon glyph={header.icon} />
        <Typography $variant="body-md-caption">{header.text}</Typography>
        {header.stars && <Stars rating={header.stars} />}
      </HeaderWrapper>
      {extraInfo.map((text, index) => (
        <ExtraInfoText $variant="body-md" key={index}>
          {text}
        </ExtraInfoText>
      ))}
    </div>
  );
};

const Title = styled(Typography)`
  margin-bottom: ${tk('spacing_lg')};
  display: inline-block;
`;

export const TripSummary = () => {
  const { tripSummary } = useTransportSelector();
  const intl = useIntl();
  return (
    // TODO those styles are temporary workaround fixing a weird bug with styled-components assigning wrong class of SkeletonPrice
    <div style={{ padding: '16px' }}>
      <Title $variant="heading-md">{intl.formatMessage({ id: 'price_basket_trip_summary_title' })}</Title>
      <SpaceBetween direction="y" spacing={tk('spacing_md')}>
        {tripSummary?.map((item, index) => <Item key={index} {...item} />)}
      </SpaceBetween>
    </div>
  );
};
